import { useEffect } from 'react';

import { User } from '@ergeon/erg-auth';

import { track } from '../utils/analytics';

const useStorageUserID = (user: User | undefined) => {
  useEffect(() => {
    if (user?.gid) {
      // Store user ID in session storage for GA4 tracking purposes.
      window.sessionStorage.setItem('user_id', user.gid);

      // Push user identification event to dataLayer
      track('user_identified', { user_id: user.gid });
    }
  }, [user]);
};

export default useStorageUserID;
